'use client'

import { datadogLogs } from '@datadog/browser-logs'
import { useEffect } from 'react'

export function DatadogBrowserLog() {
  useEffect(() => {
    const initDatadogBrowserLogs = () => {
      const clientToken = process.env.NEXT_PUBLIC_DD_CLIENT

      if (!clientToken) {
        return
      }

      datadogLogs.init({
        clientToken,
        env: process.env.NEXT_PUBLIC_ENV,
        site: 'datadoghq.eu',
        forwardErrorsToLogs: false,
        sessionSampleRate: 100,
        service: 'platform',
        usePartitionedCrossSiteSessionCookie: true,
        useSecureSessionCookie: process.env.NEXT_PUBLIC_ENV === 'production',
        beforeSend() {
          return ['production', 'staging'].includes(process.env.NEXT_PUBLIC_ENV)
        }
      })
    }

    initDatadogBrowserLogs()
  }, [])

  return null
}
